import { postApiSearchparticipantCodeVerification } from "./postApiSearchparticipantCodeVerification";
import { postApiSearchparticipantCreateElection } from "./postApiSearchparticipantCreateElection";
import { postApiSearchparticipantEmailVerification } from "./postApiSearchparticipantEmailVerification";
import { postApiSearchparticipantResendVerificationCode } from "./postApiSearchparticipantResendVerificationCode";
import { postApiSearchparticipantSearchparticipants } from "./postApiSearchparticipantSearchparticipants";

export function searchParticipantController() {
  return {
    postApiSearchparticipantSearchparticipants,
    postApiSearchparticipantEmailVerification,
    postApiSearchparticipantResendVerificationCode,
    postApiSearchparticipantCodeVerification,
    postApiSearchparticipantCreateElection,
  };
}
